const { get } = require('./api');
const debounce = require('../helpers/debounce');
const Popout = require('../components/popout');

const requestRFQ = () => {

	let popouts = [];
	let popoutTimeout;

	const $triggers = document.querySelectorAll('.js-request-rfq');

	$triggers.forEach($el => {
		const isDebug = ($el.getAttribute('data-debug') == 'true') ? true : false;
		const $submit = $el.querySelector('[data-request-rfq-submit]');
		const $qty = $el.querySelector('[data-request-rfq-qty]');
		const $form = $el.querySelector('form');
		const formAction = $form.getAttribute('action');
		const $popout = document.querySelector(`#${$el.getAttribute('data-request-rfq-popout')}`);
		const RFQType = $el.getAttribute('data-request-rfq-type');
		const RFQTypeName = $el.getAttribute('data-request-rfq-type-name') || RFQType;
		const partnr = $el.getAttribute('data-request-rfq-partnr');

		// add popout info to popouts array
		popouts.push({
			'el': $popout,
			'anchor': document.querySelector('.navbar-cart')
		});

		let apiTimeout;

		if ($qty) {
			$qty.addEventListener('input', ev => {
				ev.target.value = ev.target.value.replace(/\D/g, '');
			})
		}

		// add Success state copy if defined
		if ($submit.getAttribute('data-request-rfq-success-text') != '') {
			const $span = document.createElement('span');
			$span.classList.add('button-text-success');
			$span.innerText = $submit.getAttribute('data-request-rfq-success-text');
			$submit.appendChild($span);
		}

		$submit.addEventListener('click', ev => {
			// 1. Only submit when QTY.value is more than minimum required
			// 2. Post to API, add Loading state
			//   2A. Add Success state on success
			//   2B. Add fail state on error
			// 3. Populate Popout, Show, Remove after set Time.
			// 4. Remove Success state after set Time.
			ev.preventDefault();
			$el.classList.remove('has-error');
			if ($qty) { // 1.
				if (Number($qty.value) >= $qty.getAttribute('min')) {
					postForm($qty.value);
				} else {
					// highlight minimum state
					$el.classList.add('has-error');
					console.log(`Please input a mimimum of ${$qty.getAttribute('min')}`)
				};
			} else {
				postForm();
			}
		});

		const postForm = (qty = 1) => {
			$submit.classList.add('is-loading');
			if ($el.querySelector('.help')) $el.querySelector('.help').classList.remove('is-error');

			if (isDebug) {
				clearTimeout(apiTimeout);
				console.log('debug mode, response is Success!');
				apiTimeout = setTimeout(() => {
					onSuccess();
				}, 1500)

			} else {
				get(`${formAction}?type=${RFQType}&qty=${qty}&pn=${partnr}`, onSuccess, onFail); // 2.
			}
		}

		const onSuccess = (data) => { // 2A.
			$submit.classList.remove('is-loading');
			$submit.classList.add('is-checked');
			document
				.querySelectorAll('.js-navbar-cart')
				.forEach($cart => $cart.classList.add('has-badge'));

			// 3.
			$popout.querySelector('.popout-content .header span').innerHTML = RFQTypeName;
			$popout.querySelector('.popout-content .qty').innerHTML = $qty ? $qty.value : 1;

			Popout.open($popout);
			clearTimeout(popoutTimeout);
			popoutTimeout = setTimeout(() => {
				Popout.close($popout)
			}, 5000);

			// do this separately from the Popout, in case multiple buttons are active.
			setTimeout(() => {
				$submit.classList.remove('is-checked');
			}, 5000)
		}

		const onFail = (data) => { // 2B.
			// Failed to contact server
			$submit.classList.remove('is-loading');
		}
	});


	const alignPopout = ($popout, $anchor) => {
		// $anchor is the element the popout should stick to.

		// clear positioning
		$popout.style.top = '';
		$popout.style.left = '';
		$popout.style.right = '';
		$popout.style.bottom = '';

		// get position of $parent
		const coords = $anchor.getBoundingClientRect();
		const left = coords.left + coords.width / 2; //  center to the element
		const top = coords.top + coords.height + 20; // 20 is sharktooth height, which is a before pseudo thus we can't get its BoundingbBox #Rect.

		$popout.style.left = `${left}px`;
		$popout.style.top = `${top}px`;
	}

	const initPopouts = () => {
		popouts.forEach(item => {
			alignPopout(item.el, item.anchor)
		});

		// On debounced window resize, recalculate heights
		function onResize() {
			popouts.forEach(item => {
				alignPopout(item.el, item.anchor)
			});
		}
		const debounced = debounce(onResize, 300);
		window.addEventListener('resize', debounced);
	}

	if ($triggers.length > 0) initPopouts();

};

module.exports = {
	init: requestRFQ
};
